module.exports = __webpack_public_path__ + "static/media/julien_matthey_bell_church_ring_6_o_clock_clipped1.02c1f79a.wav";